import CoordinatorResource from './coordinator-resource';
import GoogleApiResource from '../resources/google-api-resource';
import jwtDecode from 'jwt-decode';
import { observable, reaction } from 'mobx';

class CoordinatorDetailStore {
    @observable coordinator = { name: '', email: '', displayName: '' };
    appStore;

    constructor(appStore) {
        this.appStore = appStore;
        this.coordinatorResource = new CoordinatorResource();
        this.googleApiResource = new GoogleApiResource();
    }

    analyticsReaction = reaction(
        () => {
            return {
                name: this.coordinator.name,
                email: this.coordinator.email,
                coordinatorId: this.coordinator.coordinatorId,
                partitionId: this.coordinator.partitionId,
                displayName: this.coordinator.displayName,
            };
        },
        (coordinatorData) => {
            this.appStore.analytics.identify(coordinatorData.coordinatorId, {
                name: coordinatorData.name,
                email: coordinatorData.email,
                partitionId: coordinatorData.partitionId,
                displayName: coordinatorData.displayName,
            });
        }
    );

    isAdmin() {
        return this.coordinator.hasRole('admin') || this.coordinator.hasRole('superadmin');
    }

    isSales() {
        return this.coordinator.hasRole('sales');
    }

    isTc() {
        return this.coordinator.hasRole('tc');
    }

    loadCurrentCoordinator(force) {
        let ac = this.appStore.authStore.getAccessToken(),
            decoded = jwtDecode(ac);

        if (!force && this.coordinator && decoded.sub === this.coordinator.aspNetUserId) return;

        return this.coordinatorResource.getCoordinator(ac, decoded.sub).then((coordinator) => {
            this.coordinator = coordinator;
        });
    }

    unlinkGoogleCredential() {
        if (this.coordinator && this.coordinator.hasGoogleCredentials) {
            return this.googleApiResource.deleteCredential(this.appStore.authStore.getAccessToken()).then(() => {
                this.loadCurrentCoordinator(true);
            });
        }
    }
}

export default CoordinatorDetailStore;



// WEBPACK FOOTER //
// ./src/coordinators/coordinator-detail-store.js